import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Asset, Header } from '@aptsi-types';
import { ZoneService } from '../../services/zone.service';

interface ZoneAssetsDialogData {
  zoneId: string;
  zoneName?: string;
}

@Component({
  selector: 'app-zone-assets',
  templateUrl: './zone-assets.component.html',
  styleUrls: ['./zone-assets.component.scss']
})
export class ZoneAssetsComponent implements OnInit {
  filteredAssets: Asset[] = [];
  isLoading = false;
  loadError = false;

  readonly headers: Header[] = [
    {
      name: 'Asset ID',
      property: 'assetId',
      showInDropdown: true,
      description: 'Unique identifier for the asset'
    },
    {
      name: 'Asset Name',
      property: 'assetName',
      showInDropdown: true,
      description: 'Name of the asset'
    },
    {
      name: 'Description',
      property: 'description',
      showInDropdown: true,
      description: 'Description of the asset'
    },
    {
      name: 'Business Value',
      property: 'businessValue',
      showInDropdown: true,
      description: 'Business value of the asset'
    },
    {
      name: 'Data Classification',
      property: 'dataClassification',
      showInDropdown: true,
      description: 'Data classification of the asset'
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<ZoneAssetsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ZoneAssetsDialogData,
    private readonly zoneService: ZoneService
  ) {}

  get zoneTitle(): string {
    const name = this.data?.zoneName?.trim();
    return name ? `${name} assets` : 'Assets in this zone';
  }

  ngOnInit(): void {
    this.fetchAssetsForZone(this.data?.zoneId);
  }

  fetchAssetsForZone(zoneId: string): void {
    if (!zoneId) {
      this.filteredAssets = [];
      this.loadError = true;
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.loadError = false;

    this.zoneService.getZoneAssetsByZoneId(zoneId).subscribe({
      next: (assets: Asset[]) => {
        this.filteredAssets = Array.isArray(assets) ? assets : [];
        this.isLoading = false;
      },
      error: (error: unknown) => {
        console.error('Error fetching assets for zone:', error);
        this.filteredAssets = [];
        this.loadError = true;
        this.isLoading = false;
      }
    });
  }

  retry(): void {
    this.fetchAssetsForZone(this.data?.zoneId);
  }

  back(): void {
    this.dialogRef.close();
  }
}
